<template>
    <div id="content" style="height: 100%;padding-top: 46px;" v-if="load">
        <div class="van-nav-bar van-nav-bar--fixed van-hairline--bottom">
            <div class="van-nav-bar__content">
                <div class="van-nav-bar__left van-haptics-feedback" @click="$router.go(-1)"><i
                        class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i><span
                        class="van-nav-bar__text" style="color: #000;">返回</span></div>
                <div class="van-nav-bar__title van-ellipsis">{{userInfo.gname}}</div>
            </div>
        </div>

        <div style="background: #fff;">
            <el-tabs v-model="gameType" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.gameType" v-for="(item,index) in userInfo.game"
                    :key="index"></el-tab-pane>
            </el-tabs>
            <div style="width:100%;font-size:14px;height: 40px;background: #fff;line-height: 35px;">
                <div class="dates" style="font-size:14px;display: flex;justify-content: space-around;">
                    <span id="day1" :class="index==recordIndex?'sele':''" v-for="(item,index) in userInfo.time"
                        :key="index" @click="selectTime(index)">{{item}}</span>
                </div>
            </div>
            <div style="width:100%;padding: 5px 8px;box-sizing: border-box;font-size: 12px;">
                总盈亏:<span id="totalRealYingKui">{{recordList.totalYingKui}}</span>，&nbsp;&nbsp;
                <!-- 总昨余:<span id="totalZuoYu">{{recordList.totalZuoYu}}</span>，&nbsp;&nbsp; -->
                总流水:<span id="totalRealLiuShui">{{recordList.totalLiuShui}}</span>，&nbsp;&nbsp;
                <br />
                总双边流水:<span id="totalYouXiaoLiuShuis">{{recordList.totalYouXiaoLiuShuis}}</span>，&nbsp;&nbsp;
                总单边流水:<span id="totalRealYouXiaoLiuShui">{{recordList.totalYouXiaoLiuShui}}</span>，&nbsp;&nbsp;
                <br />
                总单边返水:<span id="totalFanShui">{{recordList.totalFanShui}}</span>，&nbsp;&nbsp;
                总上下:<span id="totalUp">{{recordList.totalUp}}</span><span
                    id="totalDown">{{'-' + recordList.totalDown}}</span>&nbsp;=&nbsp;<span
                    id="totalUpDown">{{recordList.totalUpDown}}</span>&nbsp;&nbsp;
                <!-- 未飞单:<span id="flyersWait">{{recordList.flyersWait}}</span>，&nbsp;&nbsp;
                飞单成功:<span id="flyersSuc">{{recordList.flyersSuc}}</span>，&nbsp;&nbsp;
                飞单失败:<span id="flyersFail">{{recordList.flyersFail}}</span> -->
                <!-- <div style="background: rgb(239, 239, 239); padding: 5px; border: 1px solid black; font-weight: bold;">
                    总吃盈亏：<span class="fc-1">{{recordList.totalYingKuichi}}</span>，
                    总吃流水：{{recordList.totalLiuShuichi}}<br> 总吃双边流水：{{recordList.totalYouXiaoLiuShuischi}}，
                    总吃单边流水：{{recordList.totalYouXiaoLiuShuichi}}<br> 总吃单边返水：{{recordList.totalFanShuichi}}
                </div> -->
            </div>
            <div style="width:100%;">
                <button id="btnWay11" style="font-size:12px;background: none;padding: 1px 6px;height: 22px;"
                    @click="changeType">{{recordTitle}}</button>&nbsp;&nbsp;&nbsp;&nbsp;<button id="btnTime"
                    style="background: none;padding: 1px 6px;height: 22px;"
                    @click="changeTime">{{timeType==1?0:6}}点一天</button>
            </div>

            <div id="way1" style="width:100%;" v-if="recordTyIndex==1">
                <div id="content" style="margin-top:5px;margin-bottom: 50px;" class="infolist" v-loading="isLoad">
                    <div class="infoitem" v-for="(item,index) in recordList.detail" :key="index"
                        @click="ShowMyChildren(item,index)" :class="item.chi==1?'chi':''">
                    <el-collapse>
                        <el-collapse-item>
                            <template slot="title">
                        <div class="item_top">会员ID：<span class="userid">@v{{item
                            .BelongOperator}}</span>，昵称：<span class="nickname">{{item
                            .NickName}}</span>，备注：<span class="nickname">{{item
                            .remark}}</span></div>
                        <div class="all_fanshui" style="display: block;">总返水：{{item
                            .totalFanShui}}</div>
                        <div class="profit_loss">昨余: {{item
                            .ZuoYu}}，<!-- &nbsp;&nbsp; 流水: {{item
                            .totalLiuShui}}， -->&nbsp;&nbsp; 双边流水: {{item
                            .totalValidLiuShuis}}，&nbsp;&nbsp;单边流水: {{item
                            .totalValidLiuShui}}，&nbsp;&nbsp; <br />盈亏: {{item
                            .totalYingKui}},&nbsp;&nbsp;上下:&nbsp;&nbsp;{{item
                            .totalUp+'-'+item.totalDown}}=&nbsp;&nbsp;{{item
                            .totalUpDown}}
                            <div style="background: rgb(239, 239, 239); padding: 5px; border: 1px solid black;"
                                v-if="item.chi==1">
                                吃双边流水：{{item.totalValidLiuShuischi}}，吃单边流水：{{item.totalValidLiuShuichi}}，
                                <br>吃盈亏：<span>{{item.totalYingKuichi}}</span>
                            </div>
                        </div>
                                </template>
                        <div class="item_detail">
                            <div v-for="(vo, qihao) in item.list" :key="qihao">
                                <van-divider :style="{ color: '#000', borderColor: '#888'}">{{qihao}}</van-divider>
                                <div v-for="(mingxi,key) in vo" :key="key">
                                    <div v-if="mingxi.dttype==0" class="infoitem_row type2"
                                        style="margin-top: 10px; margin-bottom: 10px;"><span
                                            class="rowtype">积分操作：</span><span class="rowqi"></span><span
                                            class="rowcontent sf">{{isHas(mingxi.cmd,"转分上")?mingxi.dtNickName+'转分':'机器人'}}上分{{mingxi.score}}</span><br><span
                                            class="rowresult" style="display: block;"></span><span
                                            class="rowbefore"></span><span
                                            class="rowchange win">+{{mingxi.score}}</span><span
                                            class="fanshui"></span><span
                                            class="rowscore">{{mingxi.afterScore}}</span><br><span
                                            class="rowtime">{{mingxi.dtJieSuan}}</span></div>
                                    <div v-if="mingxi.dttype==1" class="infoitem_row type2"
                                        style="margin-top: 10px; margin-bottom: 10px;"><span
                                            class="rowtype">积分操作：</span><span class="rowqi"></span><span
                                            class="rowcontent xf">{{isHas(mingxi.cmd,"转分下")?mingxi.dtNickName+'转分':'机器人'}}下分{{mingxi.count}}</span><br><span
                                            class="rowresult" style="display: block;"></span><span
                                            class="rowbefore"></span><span
                                            class="rowchange lose">{{mingxi.count}}</span><span
                                            class="fanshui"></span><span
                                            class="rowscore">{{mingxi.afterScore}}</span><br><span
                                            class="rowtime">{{mingxi.dtJieSuan}}</span></div>
                                    <div v-if="mingxi.dttype==5&&mingxi.count>0" class="infoitem_row type1"
                                        style="margin-top: 2px;"><span class="rowtype">盈亏操作：</span><span
                                            class="rowqi">{{mingxi.qihao}}</span><span
                                            class="rowcontent">{{mingxi.cmdText}}</span><span
                                                class="rowcontent '+mingxi.flyersColor+'">{{mingxi.flyersStatus}}</span><br><span
                                            class="rowresult">{{mingxi.code}}=&gt;{{mingxi.fan}}</span><span
                                            class="rowbefore"></span><br /><span
                                            class="rowchange win">{{mingxi.count}}</span>&nbsp;&nbsp;<span
                                            class="fanshui">[返水{{mingxi.dtfanshui}}]</span>&nbsp;&nbsp;<span
                                            class="rowscore"
                                            v-if="key == vo.length-1">{{mingxi.afterScore}}</span><br><span
                                            class="rowtime">{{mingxi.dtJieSuan}}&nbsp;==&nbsp;{{mingxi.dtCmd}}
                                        </span>
                                        <span class="tuo" v-if="mingxi.chi==1">吃</span>
                                    </div>
                                    <div v-if="mingxi.dttype==5&&mingxi.count==0" class="infoitem_row type1"
                                        style="margin-top: 2px;"><span class="rowtype">盈亏操作：</span><span
                                            class="rowqi">{{mingxi.qihao}}</span><span
                                            class="rowcontent">{{mingxi.cmdText}}</span><span
                                                class="rowcontent '+mingxi.flyersColor+'">{{mingxi.flyersStatus}}</span><br><span
                                            class="rowresult">{{mingxi.code}}=&gt;{{mingxi.fan}}</span><span
                                            class="rowbefore"></span><br /><span
                                            class="rowchange win">{{mingxi.count}}</span>&nbsp;&nbsp;<span
                                            class="fanshui">{{mingxi.ying==1?'[返水' + mingxi.dtfanshui + ']':'[返水' + mingxi.dtfanshui + ']'}}</span>&nbsp;&nbsp;<span
                                            class="rowscore"
                                            v-if="key == vo.length-1">{{mingxi.afterScore}}</span><br><span
                                            class="rowtime">{{mingxi.dtJieSuan}}&nbsp;==&nbsp;{{mingxi.dtCmd}}
                                        </span>
                                        <span class="tuo" v-if="mingxi.chi==1">吃</span>
                                    </div>
                                    <div v-if="mingxi.dttype==5&&mingxi.count<0" class="infoitem_row type1"
                                        style="margin-top: 2px;"><span class="rowtype">盈亏操作：</span><span
                                            class="rowqi">{{mingxi.qihao}}</span><span
                                            class="rowcontent">{{mingxi.cmdText}}</span><span
                                                class="rowcontent '+mingxi.flyersColor+'">{{mingxi.flyersStatus}}</span><br><span
                                            class="rowresult">{{mingxi.code}}=&gt;{{mingxi.fan}}</span><span
                                            class="rowbefore"></span><br /><span
                                            class="rowchange lose">{{mingxi.count}}</span>&nbsp;&nbsp;<span
                                            class="fanshui">{{mingxi.ying==1?'[返水' + mingxi.dtfanshui + ']':'[返水' + mingxi.dtfanshui + ']'}}</span>&nbsp;&nbsp;<span
                                            class="rowscore"
                                            v-if="key == vo.length-1">{{mingxi.afterScore}}</span><br><span
                                            class="rowtime">{{mingxi.dtJieSuan}}&nbsp;==&nbsp;{{mingxi.dtCmd}}
                                        </span>
                                        <span class="tuo" v-if="mingxi.chi==1">吃</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </el-collapse-item>
                    </el-collapse>
                    </div>
                </div>
            </div>

            <div id="way2" style="width:100%;" v-if="recordTyIndex==2">
                <div id="content2" style="background-color:rgb(223,244,255);color:black;font-size:16px;">
                    <div class='tt1' v-for="(mingxi,index) in recordList" :key="index">
                        <span style='color:black;'>{{index+1}}，</span><span
                            :style="mingxi.type==0?'color:red;font-weight:bold;':'color:green;font-weight:bold;'">{{mingxi.des}}</span><span
                            style='color:black;'>【{{mingxi.dt}}】, 会员id：{{mingxi.wxid}}，昵称：{{mingxi.NickName}}</span>
                    </div>
                </div>
            </div>

            <div id="way3" style="width:100%;" v-if="recordTyIndex==3">
                <div id="content3">
                    <div id="content3_1" style="background-color:red;color:black;font-size:16px;">
                        <div v-for="(mingxi,index) in recordList.lstJiLu" :key="index" style='margin-top:6px;'>
                            <span style='color:black;font-weight:bold;'>{{mingxi.qihao}}：wxid：{{mingxi.dtwxid}},
                                昵称：{{mingxi.dtNickName}}，注：{{mingxi.zhuscore}}，
                                有效：{{mingxi.validscore}}，{{mingxi.result}}</span><span
                                style='color:black;'>，内容：{{mingxi.cmdText}},
                                结果：{{mingxi.opencode}}=>{{mingxi.lastcode}}=>{{mingxi.fan}}
                                【{{mingxi.dtJieSuan}}】入网:{{mingxi.submitStatus == 0 ? "未报" : "已报"}}</span>
                        </div>
                    </div>
                    <hr>
                    <div id="content3_2" style="background-color:white;color:black;font-size:16px;">
                        <div v-for="(mingxi,index) in recordList.lstQiDuiZhang" :key="index" style='margin-top:6px;'>
                            <span style='text-decoration:underline;'>{{mingxi.qihao}}</span>&nbsp;&nbsp;<span
                                style='color:black;font-weight:bold;'>总注:{{mingxi.totalZhu}}，</span><span
                                style='color:black;'>总盈亏：{{mingxi.totalYingKui}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="way4" style="width:100%;" v-if="recordTyIndex==4">
                <div id="content4" style="background-color:rgb(223,244,255);color:black;font-size:16px;">
                    <div v-for="(mingxi,index) in recordList" :key="index">
                        <span style='color:black;font-weight:bold;'>{{index+1}}，{{mingxi.dt}} -
                            {{mingxi.msg}}</span>
                    </div>
                </div>
            </div>

            <div id="way5" style="width:100%;" v-if="recordTyIndex==5">
                <div id="content5" style="background-color:rgb(223,244,255);color:black;font-size:16px;">
                    <div v-for="(mingxi,index) in recordList" :key="index">
                        <span style='color:black;font-weight:bold;'>{{index+1}}，{{mingxi.dt}} -
                            {{mingxi.msg}}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div id="loader-wrapper" v-else>
        <div id="loader"></div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
        <div class="load_title">{{title}}</div>
    </div>
</template>

<script>
    var ws = null,
        that = null,
        isShow = true;
    import {
        checkData
    } from '@/api/home'
    export default {
        name: 'HomePage',
        data() {
            return {
                gameType: 0,
                recordIndex: 2,
                load: false,
                title: '正在加载应用，请耐心等待',
                host: this.$store.state.baseUrl,
                userInfo: {},
                user: {},
                isLoad: false,
                value: '',
                timeType: 1,
                recordList: [],
                recordDtlIndex: 0,
                recordTyIndex: 1,
                recordTitle: '当前积分对账'
            }
        },
        // 在创建组件实例后执行
        created() {
            that = this;
            this.getInfo();
        },
        beforeDestroy() {
            isShow = false;
            ws.close();
        },
        methods: {
            isHas(str, text) {
                return str.toString().indexOf(text) !== -1 ? true : false;
            },
            changeType() {
                if (this.recordTyIndex == 1) {
                    this.recordTyIndex = 2;
                    this.recordTitle = '当前上下对账';
                    this.GetWayData('getWay2');
                } else if (this.recordTyIndex == 2) {
                    this.recordTyIndex = 3;
                    this.recordTitle = '当前记录对账';
                    this.GetWayData('getWay3');
                } else if (this.recordTyIndex == 3) {
                    this.recordTyIndex = 4;
                    this.recordTitle = '当前返水修改流水';
                    this.GetWayData('getWay4');
                } else if (this.recordTyIndex == 4) {
                    this.recordTyIndex = 5;
                    this.recordTitle = '当前赔率修改流水';
                    this.GetWayData('getWay4');
                } else {
                    this.recordTyIndex = 1;
                    this.recordTitle = '当前积分对账';
                    this.getList();
                }
            },
            GetWayData(type) {
                ws.send(JSON.stringify({
                    "type": type,
                    "day": this.userInfo.time[this.recordIndex],
                    "timeType": this.timeType,
                    "gameType": this.gameType
                }));
            },
            changeTime() {
                this.timeType = (this.timeType == 1 ? 0 : 1);
                this.updateR();
            },
            ShowMyChildren(item, index) {
                this.recordDtlIndex = index;
                this.isLoad = true;
                ws.send(JSON.stringify({
                    "type": 'getHisDtl',
                    "day": this.userInfo.time[this.recordIndex],
                    "timeType": this.timeType,
                    "wxid": item.wxid,
                    "gameType": this.gameType
                }));
            },
            selectTime(index) {
                if (this.recordIndex != index) {
                    this.recordIndex = index;
                    this.recordList = [];
                    this.updateR();
                }
            },
            updateR() {
                if (this.recordTyIndex == 2) {
                    this.GetWayData('getWay2');
                } else if (this.recordTyIndex == 3) {
                    this.GetWayData('getWay3');
                } else if (this.recordTyIndex == 4) {
                    this.GetWayData('getWay4');
                } else if (this.recordTyIndex == 5) {
                    this.GetWayData('getWay4');
                } else {
                    this.getList();
                }
            },
            async getInfo() {
                var uu = window.localStorage.getItem('rbToken');
                const data = await checkData(uu);
                this.load = true;
                if (data.status == 200) {
                    this.userInfo = data;
                    this.gameType = data.thisgame.gameType;
                    this.initWS();
                    setTimeout(function() {
                        window.location.reload();
                    },5*60*1000)
                } else {
                    this.$confirm(data.message, '系统提示', {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$router.replace('/login');
                    }).catch(() => {
                        that.getInfo();
                    });
                }
            },
            getList() {
                this.isLoad = true;
                ws.send(JSON.stringify({
                    "type": 'getHis',
                    "day": this.userInfo.time[this.recordIndex],
                    "timeType": this.timeType,
                    "gameType": this.gameType
                }));
            },
            handleClick(tab, event) {
                this.gameType = tab.name;
                this.recordList = [];
                this.updateR();
            },
            initWS() {
                ws = new WebSocket("wss://" + this.host + "/wsr6?uid=" + this.userInfo.rob.id);
                ws.onopen = function() {
                    that.updateR();
                };
                ws.onmessage = function(event) {
                    var list = JSON.parse(event.data);
                    if (list.wstype == 'getHis') {
                        that.isLoad = false;
                        that.recordList = list.message;
                    } else if (list.wstype == 'getHisDtl') {
                        that.isLoad = false;
                        that.recordList.detail[that.recordDtlIndex]['list'] = list.message;
                    } else if (list.wstype == 'getWay2' || list.wstype == 'getWay3' || list.wstype == 'getWay4') {
                        that.isLoad = false;
                        that.recordList = list.message;
                        that.recordList.totalYingKui = 0;
                        that.recordList.totalLiuShui = 0;
                        that.recordList.totalYouXiaoLiuShuis = 0;
                        that.recordList.totalYouXiaoLiuShui = 0;
                        that.recordList.totalFanShui = 0;
                        that.recordList.totalUp = 0;
                        that.recordList.totalDown = 0;
                        that.recordList.totalUpDown = 0;
                    }
                };
                ws.onclose = function() {
                    if (isShow) {
                        that.initWS();
                    }
                };
            }
        }
    }
</script>

<style>
    button {
        cursor: pointer;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 10px;
        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        text-shadow: 0 1px 1px rgba(0, 0, 0, .3);
        box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
        line-height: 0 !important;
    }

    .myTuo {
        background: red;
        color: yellow;
    }

    .myHide {
        display: none;
    }

    .myShow {
        display: inline;
    }

    .red {
        color: red;
    }

    .redbg {
        background: red;
        color: #fff;
    }

    #codelogin {
        display: none;
        width: 300px;
        height: 350px;
        border: 1px solid #000;
        position: absolute;
        top: 30px;
        left: 10px;
        background: #fff;
        z-index: 1000;
        border-radius: 10px;
    }

    #codelogin .logininp {
        position: absolute;
        top: 5px;
        left: 5px;
        width: 290px;
        height: 290px;
        background: #fbfbfb;
    }

    #codelogin .logininp input {
        width: 150px;
    }

    .selBtn {
        background-color: cadetblue;
        color: yellow;
    }

    #codelogin .logininp button.loginwxbtn {
        width: 80px;
        height: 40px;
        position: absolute;
        top: 22px;
        right: 5px;
    }

    #codelogin .wxsendsmscodeval {
        width: 60px !important;
    }

    #codelogin .wxsendsmscode {
        display: none;
    }

    #codelogin .logininp .wxmsg {
        color: red;
        word-wrap: break-word;
        width: 100%;
        height: 130px;
    }

    #codelogin .logininp b {
        color: red;
    }

    #codelogin .smdl {
        padding: 5px;
    }

    #codelogin .ewm {
        text-align: center;
    }

    #codelogin img {
        width: 290px;
        height: 290px;
        margin: 5px auto;
    }

    #wangpan {
        border: 1px solid #000;
        position: absolute;
        right: 5px;
        bottom: 5px;
        height: 100px;
        padding: 5px;
        width: 560px;
        border-radius: 10px;
    }

    .functions {
        border: 1px solid #000;
        padding: 5px;
    }

    .functions label {
        cursor: pointer;
    }

    input.inpchangeval {
        width: 40px;
        text-align: center;
        color: #fff;
    }

    input.inpchangeval.change {
        background: darkorange;
    }

    input.inpchangeval.ok {
        background: #0f5717;
    }

    .wangpanselect label {
        cursor: pointer;
    }

    #wangpan .yzm s {
        position: absolute;
        display: block;
        top: 0px;
        left: 65px;
        width: 90px;
        height: 20px;
        background: #f2f2f2;
    }

    #wangpan .yzm s img {
        display: block;
        cursor: pointer;
        width: 90px;
        height: 20px;
    }

    #wangpan .yzm input {
        width: 60px;
        margin-left: 165px !important;
    }

    #xiazhuban {
        border: 1px solid #000;
        position: absolute;
        left: 10px;
        bottom: 5px;
        height: 400px;
        width: 300px;
        border-radius: 10px;
        background: #fbfbfb;
    }

    #xiazhuban .xiazhutitle {
        margin: 5px;
    }

    #xiazhubanlist {
        border: 1px solid #000;
        height: 335px;
        overflow-y: scroll;
        padding: 0px;
    }

    #xiazhubanlist {
        padding: 0 5px;
        background: #fff;
    }

    #xiazhubanlist div b.status0 {
        color: #d5f3f7;
    }

    #xiazhubanlist div b.status1 {
        color: darkorange;
        cursor: pointer;
    }

    #xiazhubanlist div b.status2 {
        color: green;
    }

    #xiazhubanlist div b.status3 {
        color: red;
        cursor: pointer;
    }

    #xiazhubanlist div.se {
        background: #f5f5f5;
    }

    #xiazhubanlist div:hover {
        background: #d5f3f7 !important;
    }

    #xiazhubanlist div {
        position: relative;
    }

    #xiazhubanlist div s {
        position: absolute;
        color: red;
        top: 0px;
        right: 0px;
        cursor: pointer;
        text-decoration: none;
        font-weight: bold;
    }

    #dangqianzhuqi {
        font-size: 12px;
    }

    #selectqun {
        display: none;
        width: 300px;
        border: 1px solid #000;
        overflow-y: hidden;
        position: absolute;
        top: 30px;
        left: 10px;
        background: #fff;
        z-index: 100;
        border-radius: 10px;
    }

    #selectqun .tit {
        color: red;
    }

    #selectqun .changewx {
        position: absolute;
        top: 0px;
        right: 0px;
        text-align: right;
    }

    #selectqun .tit.sed {
        color: #000 !important;
    }

    #selectqun #nowqun {
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        padding-left: 5px;
        background: #fbfbfb;
    }

    #selectqun #nowqun span {
        color: green;
    }

    #selectqunlist {
        margin-top: 5px;
        height: 230px;
        overflow-y: scroll;
    }

    #refquninfo {
        margin: 5px;
    }

    #selectqunlist div {
        background: #f2f2f2;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
    }

    #selectqunlist div.sele {
        background: #0f5717 !important;
        color: #fff !important;
    }

    #selectqunlist div:hover {
        background: #808080;
        color: #fff;
    }

    .topframe {
        width: 900px;
        height: 800px;
        border: 2px solid #000;
        margin: 2px auto;
        position: relative;
        border-radius: 10px;
        background: #fefefe;
    }

    #kaipanstatus {
        visibility: hidden;
    }

    .kaipanstatustit {
        color: red;
    }

    .kaipanstatustit.sed {
        color: #000 !important;
    }

    .shangxiafentit.sed {
        color: red !important;
    }

    .scoremm {
        position: absolute;
        right: 200px;
        top: 5px;
        z-index: 1;
    }

    .tophead {
        padding: 5px;
        position: relative;
    }

    .topheadmenu {
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 1;
    }

    .topheadmenu span {
        font-weight: bold;
        color: darkgreen;
        cursor: pointer;
    }

    .divchangepwd {
        position: absolute;
        right: 5px;
        top: 0;
        border: 1px solid #000;
        border-radius: 10px;
        padding: 0 10px;
        z-index: 2;
        background: #fff;
        display: none;
    }

    .divchangepwd input {
        width: 50px;
    }

    .rightframe {
        position: absolute;
        right: 5px;
        top: 30px;
        width: 570px;
        border: 1px solid #000;
        border-radius: 10px;
    }

    .right_top {
        padding: 5px;
        position: relative;
    }

    .yuliufengpan input {
        width: 40px;
        text-align: center;
        color: #fff;
    }

    .yuliufengpan input.change {
        background: darkorange;
    }

    .yuliufengpan input.err {
        background: red;
    }

    .yuliufengpan input.ok {
        background: #0f5717;
    }

    .peilv {
        padding: 2px 0 0 5px;
        position: absolute;
        background: #fff;
        top: 2px;
        right: 290px;
        border: 1px solid #000;
        height: 30px;
        width: 100px;
        line-height: 30px;
        border-radius: 10px;
    }

    .peilv input {
        width: 45px;
        text-align: center;
        color: #fff;
    }

    .peilv input.change {
        background: darkorange;
    }

    .peilv input.err {
        background: red;
    }

    .peilv input.ok {
        background: #0f5717;
    }

    .fanshuiSet {
        padding: 2px 0 0 5px;
        position: absolute;
        top: 2px;
        right: 135px;
        border: 1px solid #000;
        height: 30px;
        width: 135px;
        line-height: 30px;
        border-radius: 10px;
    }

    .fanshuiSet input {
        width: 45px;
        text-align: center;
        color: #fff;
    }

    .fanshuiSet input.change {
        background: darkorange;
    }

    .fanshuiSet input.err {
        background: red;
    }

    .fanshuiSet input.ok {
        background: #0f5717;
    }

    #selefocus {
        position: absolute;
        background: #fff;
        border: none;
        right: 3px;
        display: block;
        width: 1px;
        height: 0px;
        top: 3px;
        z-index: 1;
    }

    .dingwei {
        padding: 2px 0 0 5px;
        position: absolute;
        top: 2px;
        right: 10px;
        background: #fff;
        border: 1px solid #000;
        height: 30px;
        width: 260px;
        z-index: 100;
        border-radius: 10px;
    }

    .dingwei-ul {
        position: absolute;
        top: 2px;
        left: 50px;
        border: 1px solid #000;
        width: 160px;
        height: 25px;
    }

    .dwtitle {
        line-height: 30px;
    }

    .dingwei button {
        position: absolute;
        top: 1px;
        right: 1px;
    }

    .dingwei.change li {
        cursor: pointer;
    }

    .dingwei-ul li {
        display: block;
        text-align: center;
        background: #f2f2f2;
        line-height: 25px;
        width: 18px;
        height: 25px;
        border: 1px solid #000;
    }

    .dingwei-ul li.se {
        background: #0f5717 !important;
        color: #fff;
    }

    .dingwei.change li:hover {
        text-align: center;
        background: #31a924;
        color: #fff;
    }

    .jifen {
        position: relative;
        padding: 5px;
        border: 1px solid #000;
        height: 330px;
        border-radius: 0 0 10px 10px;
    }

    .jifenleftlist {
        padding: 5px;
        position: absolute;
        bottom: 5px;
        left: 5px;
        border: 1px solid #000;
        width: 280px;
        height: 280px;
        overflow-y: scroll;
        border-radius: 0 0 0 10px;
    }

    .jifenleftlist i {
        position: absolute;
        background: green;
        left: 0px;
        color: #fff;
        /* background-color: navajowhite; */
        display: none;
        width: 30px;
    }

    .jifenleftlist i.t,
    .jifenleftlist i.h {
        display: inline !important;
        text-align: center;
    }

    .jifenleftlist i.t {
        display: inline !important;
        background: blue !important;
        color: #fff;
    }

    .jifenleftlist i:hover {
        color: darkorange;
    }

    .jifenleftlist u {
        position: absolute;
        background: #f2f2f2;
        left: 18px;
        color: green;
        display: none;
    }

    .jifenleftlist u.t,
    .jifenleftlist u.h {
        display: inline !important;
    }

    .jifenleftlist u.t {
        display: inline !important;
        background: green !important;
        color: #fff;
    }

    .jifenleftlist u:hover {
        color: darkorange;
    }

    .jifenleftlist s {
        color: red;
        margin-left: 20px;
    }

    .jifenleftlist div {
        text-align: right;
        position: relative;
    }

    .jifenleftlist span {
        margin-right: 10px;
    }

    .jifenright {
        position: absolute;
        padding: 5px;
        width: 245px;
        height: 280px;
        bottom: 5px;
        right: 5px;
        border: 1px solid #000;
        border-radius: 0 0 10px 0;
    }

    .jifenright .headimg {
        position: absolute;
        width: 64px;
        height: 64px;
        right: 5px;
        top: 110px;
        border: 1px solid #000;
        border-radius: 4px;
        cursor: pointer;
    }

    .myheadimg {
        position: relative;
        width: 64px;
        height: 64px;
        right: -5px;
        top: 5px;
        border: 1px solid #000;
        border-radius: 4px;
    }

    .jifenright .create_user {
        position: absolute;
        right: 5px;
        top: 5px;
    }

    .jifenright .create_real {
        position: absolute;
        right: 75px;
        top: 5px;
    }

    .jifenright div {
        margin-bottom: 5px;
    }

    .jifenleftlist .se {
        background: #f5f5f5;
    }

    .jifenleftlist div:hover {
        background: #d5f3f7 !important;
    }

    .jifenmessage {
        color: red;
    }

    .jifenleftlist div {
        cursor: pointer;
    }

    .sxf {
        padding: 5px;
        border: 1px solid #000;
        height: 180px;
    }

    .sxf .sxftitle {
        font-weight: bold;
    }

    .sxf .sxflist {
        border: 1px solid #000;
        height: 87%;
        overflow-y: scroll;
    }

    .sxf .sxflist .sxfitem {
        position: relative;
        height: 30px;
        line-height: 30px;
    }

    .sxf .sxflist .sxfitem.se {
        background: #f5f5f5;
    }

    .sxf .sxflist .sxfitem:hover {
        background: #d5f3f7;
    }

    .sxf .sxflist .content {
        display: block;
        padding-left: 10px;
    }

    .sxf .sxflist .sxfitem i {
        font-weight: bold;
        color: darkblue;
        display: none;
        top: 0px;
        left: 0px;
    }

    .sxf .sxflist .sxfitem.tuo i {
        display: inline !important;
    }

    .sxf .sxflist .sxfbtns {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 120px;
    }

    .sxf .sxflist .sxfbtns span {
        display: block;
        position: absolute;
        width: 45px;
        top: 2px;
        height: 25px;
        line-height: 20px;
        padding: 2px 5px;
        cursor: pointer;
        background: #fff;
        z-index: 10;
        text-align: center;
    }

    .sxf .sxflist .sxfbtns span.ty {
        background: #c9efb5;
        color: #000;
        left: 0px;
        border: 1px solid #000;
    }

    .sxf .sxflist .sxfbtns span.ld {
        display: none;
        background: #fff;
        color: #000;
        opacity: 0.5;
        top: 0px;
        width: 99px;
        height: 28px;
        left: 0px;
        cursor: default;
        z-index: 20;
        filter: alpha(opacity=1);
        -moz-opacity: 0.01;
        -khtml-opacity: 0.01;
    }

    .sxf .sxflist .sxfbtns span.ty:hover {
        background: #31a924;
        color: #fff;
    }

    .sxf .sxflist .sxfbtns span.qx {
        background: #f2f2f2;
        color: #000;
        left: 60px;
        border: 1px solid #000;
    }

    .sxf .sxflist .sxfbtns span.qx:hover {
        background: #808080;
        color: #fff;
    }

    .black {
        background-color: yellow;
        color: black;
    }

    .fake,
    .zhui {
        background-color: rgb(255, 131, 71);
        color: white;
        margin-left: 3px;
        margin-right: 3px;
    }

    .uk-modal.uk-open {
        display: flex !important;
        align-items: center;
    }

    button {
        box-shadow: none;
        background: #ffffff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        font-size: 14px;
        padding: 8px;
        height: 32px;
        line-height: 1;
        color: #606266;
    }

    .fanshuiSet2,
    .peilv2 {
        padding: 2px 0 0 5px;
        position: absolute;
        top: 4px;
        right: 135px;
        border: 1px solid #000;
        height: 30px;
        width: 135px;
        line-height: 30px;
        border-radius: 10px;
    }

    .fanshuiSet2 input.ok,
    .peilv2 input.ok {
        background: #0f5717;
        text-align: center;
        color: #fff;
    }

    .peilv,
    .fanshuiSet,
    .peilv2,
    .fanshuiSet2 {
        /*width: 100px;*/
        /*position: static;*/
        /*float: left;*/
        margin-left: 8px;
        height: 37px;
    }

    .fanshuiSet input,
    .peilv input,
    .peilv2 input,
    .fanshuiSet2 input {
        width: 35px;
    }

    .jifenleftlist i {
        position: inherit;
    }

    .selBtn {
        background: #409eff;
        color: #fff;
    }

    .uk-width-1-3,
    .uk-width-2-6 {
        width: 60%;
        padding-left: 20px;
        font-size: 12px;
    }

    .uk-width-2-3,
    .uk-width-2-6 {
        width: 33%;
    }

    #kaipanstatus.sed {
        color: #909399 !important;
        border-color: #909399 !important;
    }

    .el-overlay {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2000;
        height: 100%;
        background-color: #00000080;
        overflow: auto;
    }

    .main {
        display: flex;
        justify-content: space-around;
        padding-bottom: 5px;
    }

    #codelogin,
    #xiazhuban,
    .rightframe,
    #codelogin .logininp {
        position: inherit;
    }

    #codelogin .logininp {
        margin: 5px;
        height: 275px;
    }

    #codelogin .logininp b {
        color: inherit;
    }

    .alertBox {
        width: 920px;
        margin: 4px auto;
        position: relative;
    }

    .topframe {
        width: 920px;
        height: auto;
    }

    #codelogin {
        display: block;
        height: 285px;
    }

    #xiazhuban {
        overflow: hidden;
        height: calc(100% - 300px);
        margin-top: 8px;
    }

    #wangpan {
        height: auto;
        width: 565px;
        position: static;
        margin-top: 0;
        border: none;
    }

    #xiazhubanlist {
        border: none;
        border-top: 1px solid #000;
    }

    .rightframe {
        width: 590px;
    }

    .functions {
        border: none;
        border-top: 1px solid #000;
    }

    #el-id-7854-9 .uk-width-1-3 {
        width: 45%;
        text-align: right;
    }

    #el-id-7854-9 .uk-width-2-3 {
        width: 54%;
    }

    .el-dialog {
        width: 100vw !important;
        min-height: 100vh;
        margin: 0 !important;
    }

    .el-dialog__wrapper {
        width: 100vw;
    }

    .uk-modal-footer {
        margin: 0 -20px -20px -20px;
        border-top: none;
        background: none;
    }

    .js-modal-confirm {
        margin-right: 10px;
    }

    .layui-layer-title {
        border-bottom: none;
    }

    /* button, */
    input,
    textarea {
        line-height: 24px !important;
        /* font: initial; */
        /* font-size: 100%; */
    }

    .el-message-box {
        max-width: 100%;
    }

    .LeftScore {
        color: black;
        font-size: 16px;
        font-weight: bold;
    }

    .tshow {
        font-size: 16px;
    }

    .thide {
        font-size: 16px;
    }

    .Cmd {
        color: black;
        font-size: 16px;
        background-color: yellow;
    }

    .DownScore {
        color: white;
        background-color: green;
    }

    .UpScore {
        color: white;
        background-color: red;
    }

    .mingxiHide {
        display: none;
    }

    .ToHide {
        display: none;
    }

    .ToShow {
        display: block;
    }

    .dates span,
    .types span {
        margin-left: 10px;
        cursor: pointer;
        position: relative;
    }

    .dates span.sele,
    .types span.sele {
        font-weight: 500;
    }

    .dates span.sele:after,
    .types span.sele:after {
        border-bottom: 3px solid #ee0a24;
        position: absolute;
        content: '';
        width: 40px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
    }

    .types span.sele:after {
        border-bottom: 3px solid #0af;
    }

    .infoitem {
        border-radius: 4px;
        border: 1px solid #000;
        background: #dff4ff;
        margin: 2px;
        padding: 5px;
    }

    .infoitem.chi {
        background: #b2b2de;
    }

    .infoitem.sele {
        border: 2px solid orange;
    }

    .liu {
        border: 2px solid orange;
    }

    .infoitem.is_excep {
        background: red;
        color: #fff;
    }

    .infoitem.is_excep .infoitem_row {
        background: #fcc9c9 !important;
        color: #000000 !important;
    }

    .infoitem.is_excep .all_fanshui {
        color: #ffffff !important;
    }

    .infoitem.is_tuo {
        background: #b2b2de;
    }

    .infolist .item_top span {
        font-weight: bold;
        margin: 2px;
    }

    .infolist .infoitem_row {
        position: relative;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid #000;
    }

    .infoitem_row.type1 {
        background: #efefef;
    }

    .infolist .infoitem_row span {
        margin-right: 0px;
    }

    .infolist .infoitem_row .rowqi {
        display: inline-block;
    }

    .infolist .infoitem_row span.tuo {
        position: absolute;
        top: -10px;
        left: 67px;
        background: darkblue;
        display: block;
        width: 20px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent {
        padding: 2px;
        background: #808080;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.sf {
        background: red;
        color: #fff;
    }

    .infolist .infoitem_row .rowcontent.xf {
        background: green;
        color: #fff;
    }

    .infolist .infoitem_row .fanshui {
        color: red;
        font-size: 14px;
    }

    .infolist .infoitem_row .rowchange.win {
        color: red;
    }

    .infolist .infoitem_row .rowchange.lose {
        color: green;
    }

    .infolist .infoitem_row .rowscore {
        font-weight: bold;
    }

    .infolist .profit_loss.changescore:before {
        content: '改分';
        color: #ffffff;
        background: red;
        font-weight: bold;
    }

    .infolist .all_fanshui {
        color: red;
        display: none;
        font-weight: bold;
    }

    .item_detail {}

    .tt1 {
        margin-top: 5px;
        font-size: 16px;
    }

    .custom-block.tip {
        padding: 8px 16px;
        background-color: #409eff1a;
        border-radius: 4px;
        border-left: 5px solid #409eff;
        margin: 20px 0;
    }

    .custom-block .custom-block-title {
        font-weight: 700;
        margin-bottom: 8px;
        font-size: 16px;
    }

    body {
        font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;
        font-size: 14px;
    }

    ./* el-tabs__nav-wrap::after {
        height: 0px !important;
    }

    .el-tabs__header {
        margin: 0 !important;
    } */

    .el-collapse {
        border: none !important;
    }

    .el-collapse-item__header {
        display: block !important;
        height: auto !important;
        line-height: inherit !important;
        background: none !important;
        border-bottom: none !important;
        font-size: inherit !important;
        font-weight: inherit !important;
    }

    .el-collapse-item__arrow {
        display: none !important;
    }

    .el-collapse-item__wrap {
        background: none !important;
        border-bottom: none !important;
    }

    .el-collapse-item__content {
        padding-bottom: 0 !important;
        font-size: inherit !important;
        line-height: inherit !important;
    }
</style>
